import { cn as e } from "../utils/index.js";
import { Icon as t } from "./icons/icons.js";
import "./icons/index.js";
import "react";
import { jsx as n } from "react/jsx-runtime";
import * as r from "@radix-ui/react-checkbox";
//#region src/components/checkbox.tsx
function i({ className: i, ...a }) {
	return /* @__PURE__ */ n(r.Root, {
		"data-slot": "checkbox",
		className: e("peer text-white border-(--neutral-200) bg-white data-[state=checked]:bg-(--seafoam-500) data-[state=checked]:border-(--seafoam-500) data-[state=checked]:hover:bg-(--seafoam-600) data-[state=checked]:hover:border-(--seafoam-600) hover:border-(--seafoam-500) focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50", i),
		...a,
		children: /* @__PURE__ */ n(r.Indicator, {
			"data-slot": "checkbox-indicator",
			className: "grid place-content-center text-current transition-none",
			children: /* @__PURE__ */ n(t, {
				name: "check",
				size: "sm"
			})
		})
	});
}
//#endregion
export { i as Checkbox };
